import { z } from 'zod';

const plotSchema = z.object({
  plotId: z.string(),
  unlocked: z.boolean(),
  cropId: z.string().nullable(),
  plantedAtUtc: z.number().nullable(),
  harvestCount: z.number().int().nonnegative(),
});

const placementSchema = z.object({
  instanceId: z.string(),
  furnitureId: z.string(),
  roomId: z.string(),
  gridX: z.number().int(),
  gridY: z.number().int(),
  rotation: z.union([z.literal(0), z.literal(90), z.literal(180), z.literal(270)]),
  layer: z.enum(['floor', 'furniture', 'wall']),
});

const outfitSchema = z.object({
  id: z.string(),
  name: z.string(),
  equipped: z.record(z.string(), z.string()),
});

const questProgressSchema = z.object({
  questId: z.string(),
  progress: z.number().int().nonnegative(),
  claimed: z.boolean(),
});

export const gameStateSchema = z.object({
  schemaVersion: z.literal(2),
  createdAtUtc: z.number(),
  lastSavedAtUtc: z.number(),
  player: z.object({
    playerId: z.string(),
    level: z.number().int().min(1).max(15),
    xp: z.number().int().nonnegative(),
    coins: z.number().int().nonnegative(),
    warehouseCapacity: z.number().int().positive(),
  }),
  inventory: z.record(z.string(), z.number().int().nonnegative()),
  farm: z.object({ plots: z.array(plotSchema), lastSeenUtc: z.number() }),
  home: z.object({
    houseLevel: z.number().int().min(1).max(5),
    ownedFurniture: z.record(z.string(), z.number().int().nonnegative()),
    placements: z.array(placementSchema),
    draftPlacements: z.array(placementSchema).nullable(),
  }),
  wardrobe: z.object({
    ownedClothingIds: z.array(z.string()),
    equipped: z.record(z.string(), z.string()),
    preview: z.record(z.string(), z.string()).nullable(),
    savedOutfits: z.array(outfitSchema).max(5),
  }),
  quests: z.object({
    dateKey: z.string(),
    daily: z.array(questProgressSchema),
    growth: z.array(questProgressSchema),
  }),
  collection: z.object({
    discoveredCropIds: z.array(z.string()),
    discoveredFurnitureIds: z.array(z.string()),
    discoveredClothingIds: z.array(z.string()),
    seenIds: z.array(z.string()),
    claimedCategoryRewardIds: z.array(z.enum(['crop', 'furniture', 'clothing', 'house'])),
  }),
  tutorial: z.object({ step: z.number().int().nonnegative(), completed: z.boolean() }),
});

export const saveDataSchema = z.object({
  schemaVersion: z.literal(2),
  saveId: z.string(),
  createdAtUtc: z.number(),
  lastSavedAtUtc: z.number(),
  game: gameStateSchema,
});
